module.exports = __webpack_public_path__ + "media/images/voice_banner-5161cad22712e702d578300c0aa8820f.jpg";